import { PromoCallToActionContent } from '@kp/shared/components/promo/promo-content.model';
import { ContentImage, Deserializable, JsonObject } from '@ktypes/models';

export class Promo implements Deserializable<JsonObject, Promo> {
  constructor(
    public id?: string,
    public title?: string,
    public description?: string,
    public ctaText?: string,
    public labelText?: string,
    public dismissible = false,
    public image?: ContentImage,
    public ctaContent?: PromoCallToActionContent
  ) {}

  deserialize(input: JsonObject): Promo {
    if (input == null) {
      return null;
    }
    this.id = input['promoContentId'];
    this.title = input['title'];
    this.description = input['description'];
    this.ctaText = input['callToActionText'];
    this.labelText = input['labelText'];
    this.dismissible = input['dismissible'];
    this.image = new ContentImage().deserialize(input['image']);
    this.ctaContent = new PromoCallToActionContent().deserialize(input['ctaContent']);

    return this;
  }
}
